import { createTRPCReact, httpBatchLink } from '@trpc/react-query';
import type { AppRouter } from '../../../api/src';
import { useState } from 'react';
import { QueryClient } from '@tanstack/react-query';
import { inferRouterInputs, inferRouterOutputs } from '@trpc/server';
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
import { persistQueryClient } from '@tanstack/react-query-persist-client';

export const trpc = createTRPCReact<AppRouter>();

export type RouterInput = inferRouterInputs<AppRouter>;
export type RouterOutput = inferRouterOutputs<AppRouter>;

const useTrpc = () => {
	const [queryClient] = useState(
		() =>
			new QueryClient({
				defaultOptions: {
					queries: {
						gcTime: Infinity,
						staleTime: 60 * 1000 * 5, // 5 minutes,
					},
				},
			})
	);
	const [trpcClient] = useState(() =>
		trpc.createClient({
			links: [
				httpBatchLink({
					url: `${import.meta.env.VITE_API_URL}/trpc`,
					fetch(url, options) {
						return fetch(url, {
							...options,
							credentials: 'include',
						});
					},
				}),
			],
		})
	);

	const persister = createSyncStoragePersister({
		storage: window.localStorage,
	});

	// persistQueryClient({
	// 	queryClient,
	// 	persister,
	// 	buster: 'v1',
	// 	maxAge: Infinity,
	// });

	return { trpcClient, queryClient };
};

export default useTrpc;
